export default __webpack_public_path__ + "static/media/ethereum-classic-etc-logo.118031f6.svg";